/* ============================================================
   v212 — psi-cart-instant.js
   Subtotale e barra spedizione aggiornati nell'istante del clic.

   IL PROBLEMA CHE RISOLVE
   In assets/theme.js il gestore dei pulsanti quantita' aggiorna subito il numero
   della riga e il prezzo di riga, ma NON il subtotale ne' la barra della
   spedizione: quelli aspettano la risposta di /cart/change.js. Nel frattempo il
   tema applica le classi psi-sync e psi-fs-syncing, che in theme.css valgono
   opacity:.5 — subtotale e scritta spedizione si sbiadiscono.
   Con clic rapidi le chiamate si accodano (cartEnqueue le mette in fila), quindi
   lo sbiadimento resta acceso per tutta la sequenza: da qui la sensazione che il
   carrello "pensi".

   PERCHE' NON HO PATCHATO theme.js
   Il CDN di Shopify minifica gli asset del tema: il file servito e' 48 KB, quello
   nel tema 64 KB. Le stringhe del file minificato non esistono nella sorgente che
   si apre in Modifica codice, quindi un trova-e-sostituisci basato su quelle non
   troverebbe niente. Riscrivere 64 KB di sorgente per tre righe e' un rischio
   sproporzionato. Questo file invece si aggiunge e non modifica nulla.

   COME CONVIVE CON theme.js
   Il gestore del tema resta al suo posto e continua a fare il suo lavoro. Questo
   file ascolta gli stessi eventi in fase di risalita, cioe' DOPO, e ricalcola
   subtotale e barra dal DOM. Quando poi arriva la risposta del server, il tema
   riscrive gli stessi valori: se combaciano non si vede alcun salto, e se il
   server dice qualcosa di diverso (uno sconto, una promozione) vince lui, com'e'
   giusto.

   La formula del prezzo e i testi della barra sono gli stessi di theme.js, copiati
   volutamente identici: se un domani cambiano la', vanno cambiati anche qui,
   altrimenti il numero locale e quello del server divergono e il salto ricompare.

   L'ascoltatore e' delegato su #cart-drawer, che non viene mai sostituito: il
   tema riscrive solo l'interno di #cart-drawer-body e #cart-drawer-footer.
   Percio' continua a funzionare anche dopo una ricostruzione completa del cassetto.
   ============================================================ */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  /* Stessa formattazione di psiMoney in theme.js: separatore di migliaia con il
     punto, decimali con la virgola, simbolo davanti. Serve che sia identica,
     altrimenti al ritorno del server il testo cambierebbe forma anche a parita'
     di importo. */
  function money(cents) {
    cents = Math.round(cents || 0);
    var neg = cents < 0 ? '-' : '';
    cents = Math.abs(cents);
    var e = Math.floor(cents / 100), c = cents % 100;
    var eStr = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return neg + '\u20AC' + eStr + ',' + (c < 10 ? '0' + c : c);
  }

  function refresh() {
    var total = 0;

    /* :not(.is-removing) esclude le righe in uscita: quando si toglie un
       articolo il tema gli assegna quella classe e le anima l'altezza a zero,
       ma l'elemento resta nel DOM per la durata dell'animazione. Contarlo
       significherebbe mostrare per mezzo secondo un totale che comprende una
       cosa gia' rimossa. */
    drawer.querySelectorAll('.cart-item:not(.is-removing)').forEach(function (li) {
      var qEl = li.querySelector('.qty-num');
      if (!qEl) return;
      var q = parseInt(qEl.tagName === 'INPUT' ? qEl.value : qEl.textContent, 10) || 0;
      var pEl = li.querySelector('.cart-item-price');
      var unit = pEl ? (parseInt(pEl.dataset.unitPrice, 10) || 0) : 0;
      total += unit * q;
    });

    var sub = document.getElementById('cart-subtotal');
    if (sub) sub.textContent = money(total);

    var bar = drawer.querySelector('.psi-fs-bar');
    if (!bar) return;
    var thr = parseInt(bar.dataset.threshold, 10) || 0;
    if (thr <= 0) return;

    var fill = bar.querySelector('.psi-fs-fill');
    if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / thr)) + '%';

    var txt = bar.querySelector('.psi-fs-text');
    if (total >= thr) {
      bar.classList.add('psi-fs-done');
      if (txt) txt.innerHTML = '\u2713 Hai ottenuto la <b>spedizione gratuita</b>';
    } else {
      bar.classList.remove('psi-fs-done');
      if (txt) txt.innerHTML = 'Ti mancano <b>' + money(thr - total) + '</b> per la <b>spedizione gratuita</b>';
    }
  }

  /* Fase di risalita (terzo argomento assente = false): il gestore del tema e'
     agganciato direttamente al pulsante, quindi gira prima. Il doppio
     requestAnimationFrame garantisce di leggere il DOM dopo che ha finito di
     scriverlo, anche se in futuro quel gestore diventasse asincrono. */
  function pianifica() {
    requestAnimationFrame(function () { requestAnimationFrame(refresh); });
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.qty-btn')) pianifica();
  });

  /* Il campo quantita' scritto a mano: il tema lo conferma su change e su blur */
  drawer.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('qty-num')) pianifica();
  });
  drawer.addEventListener('keyup', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('qty-num')) pianifica();
  });
}());
